import styled from 'styled-components';
import { Button } from '../Button';

export const Container = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center; 

  gap: 10px;
  margin-left: auto;
`;

export const Input = styled.input`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  font-size: 13px;
  line-height: 1;
  height: 35px;
  width: 100%;
  background-color: ${props => props.theme.colors.card_300};
  color: ${props => props.theme.colors.primary};
  border: 1px solid;
  border-color: ${props => props.theme.colors.primary};

  &:hover {
    background-color: ${props => props.theme.colors.hover};
  }

  &:focus {
    box-shadow: 0 0 0 2px black;
  }

  &[data-placeholder] {
    color: ${props => props.theme.colors.primary};
  }
`;

export const PaginationButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

export const HiddenInput = styled(Input)`
  display:none;
  visibility:hidden
`;

